import React from "react";

const ManualCustomerEntry = ({
  show,
  manualCustomers,
  errors,
  handleChange,
  handleAddCustomer,
}) => {
  if (!show) return null;

  return (
    <div className="manual-entry-section mb-4" style={{ margin: "30px 0px 0px 4px" }}>
      <div className="row" style={{ marginBottom: 10 }}>
        {/* Name Input */}
        <div className="col-md-5">
          <input
            type="text"
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            placeholder="Name"
            value={manualCustomers.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
          {errors.name && (
            <div className="error invalid-feedback d-block" style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>
              {errors.name}
            </div>
          )}
        </div>

        {/* Phone Number Input */}
        <div className="col-md-5">
          <input
            type="text"
            className={`form-control ${errors.phone_number ? "is-invalid" : ""}`}
            placeholder="(000)000-0000"
            value={manualCustomers.phone_number}
            onChange={(e) => handleChange("phone_number", e.target.value)}
          />
          {errors.phone_number && (
            <div className="error invalid-feedback d-block" style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>
              {errors.phone_number}
            </div>
          )}
        </div>

        {/* Add Button */}
        <div className="col-md-1">
          <button
            type="button"
            className="btn add-link"
            title="Add"
            style={{ fontSize: "14px" }}
            onClick={handleAddCustomer}
          >
            +Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManualCustomerEntry;
